import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const timezoneSchema = z.object({
    created_at: zDayJs.nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
    value: z.string().nullish(),
})

export const timezonesSchema = z.array(timezoneSchema)

export const paginatedTimezonesResponseSchema = z.object({
    data: timezonesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTimezoneResponseSchema = z.object({
    data: timezoneSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type PaginatedTimezonesResponse = z.infer<typeof paginatedTimezonesResponseSchema>
export type Timezone = z.infer<typeof timezoneSchema>
export type Timezones = z.infer<typeof timezonesSchema>
export type RetrieveTimezoneResponse = z.infer<typeof retrieveTimezoneResponseSchema>
